module.exports = "/img/pageLogo2.186f5ed1.webp";